<script>
  import { typewriter } from "../../actions/typewriter";
  import { allowAnimation } from "../../stores/prefers-reduced-motion.js";

  export let mounted;
  export let currentPoem;

  $: lines = currentPoem.split("\n");
</script>

<style>
  @keyframes blink {
    from,
    to {
      border-color: lime;
    }

    50% {
      border-color: transparent;
    }
  }

  .invisible {
    opacity: 0;
  }

  :global(.active-line::after) {
    content: "";
    border-right-color: lime;
    border-right-style: solid;
    border-right-width: 5px;
    animation: 1s blink step-end infinite;
  }

  @media (prefers-reduced-motion) {
    :global(.active-line::after) {
      border-right: none;
      animation: none;
    }
  }
</style>

{#if mounted}
  {#key lines}
    <p aria-hidden="true" use:typewriter>
      {#each lines as line}
        <span class:invisible="{$allowAnimation}">{@html line}</span><br />
      {/each}
    </p>
  {/key}
{/if}
